import React, { FC } from "react";
import { ListItemText, ListItemTextProps } from "@mui/material"

const ListItemTextWrapper: FC<ListItemTextProps> = ({...props}) => <ListItemText {...props}/>

export default ListItemTextWrapper;